import { crossCloserHandler } from "../scripts/crossCloserHandler";

const closer = document.querySelector(".cross_closer__menu");
const menu = document.querySelector(".wrap_side_menu");

const isClosed = (menu) => {
    if (!menu) return;
    return menu.classList.contains("close");
};

export const closeMenu = ({ duration, instant }) => {
    if (!isClosed(menu)) {
        crossCloserHandler(closer, { duration, instant });
    }
};
